import React from "react";

import { useModalAdapter } from "hooks";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";
import { CreateExternalAgentSaleFromSaleModal } from "./CreateExternalAgentSaleFromSaleModal";

interface ParamsReturns {
  saleId: number;
}

const CreateExternalAgentSaleFromSaleAdapter = (props: ModalAdapterProps) => {
  const [hashParams, ignored, onClose] = useModalAdapter<ParamsReturns>(
    ModalTypes.CreateExternalAgentSaleFromSale,
    props,
  );

  const { saleId } = hashParams;

  return (
    <CreateExternalAgentSaleFromSaleModal onClose={onClose} saleId={saleId} />
  );
};

export default CreateExternalAgentSaleFromSaleAdapter;
